import TechniqueCalculation from './TechniqueCalculation';

export default TechniqueCalculation;
